import { api } from "../api";

// Rewritten 2026-09-03 (same UI/UX pass as Connections/Client Detail/Fleet).
// This page used to be metadata only (name, page type, version, created) —
// no way to see what a template actually CONTAINS without going to the
// database or the source repo, even though the backend has had a full
// GET /templates/:id (returns the real html) and a POST /:id/preview
// (renders it against sample data, with lint results) since Phase 2. Not
// building a full editor here — that's real new scope, not a UI/UX pass —
// but there's no reason the read-only html should stay invisible when the
// data's one cheap fetch away. Each row is now a collapsed accordion (same
// pattern as Connections); expanding it lazy-fetches that one template's
// full record and shows the raw HTML in a read-only <pre> block.
export async function templatesView(root: HTMLElement) {
  root.innerHTML = `<div class="topbar"><h1>Templates</h1></div><div id="content">Loading…</div>`;
  await savedTemplatesPanel(root.querySelector<HTMLElement>("#content")!);
}

/** The saved page templates list, without a page header: used as the "Saved templates" tab of Template Studio. */
export async function savedTemplatesPanel(content: HTMLElement) {
  content.textContent = "Loading…";
  try {
    const { templates } = await api<{ templates: any[] }>("/v1/templates");
    if (templates.length === 0) {
      content.innerHTML = `<div class="empty">No templates seeded yet.</div>`;
      return;
    }

    content.innerHTML = templates
      .map(
        (t: any) => `
        <div class="accordion" data-id="${t.id}">
          <button type="button" class="accordion-head">
            <span class="chevron">▸</span>
            <span class="title">${escapeHtml(String(t.name ?? ""))}</span>
            <span class="tag">${escapeHtml(String(t.page_type ?? ""))}</span>
            <span class="subtitle">version ${t.active_version}</span>
            <span class="muted" style="flex-shrink:0">${new Date(t.created_at * 1000).toLocaleDateString()}</span>
          </button>
          <div class="accordion-body" hidden></div>
        </div>`,
      )
      .join("");

    content.querySelectorAll<HTMLButtonElement>(".accordion-head").forEach((head) => {
      head.onclick = async () => {
        const acc = head.closest<HTMLElement>(".accordion")!;
        const body = acc.querySelector<HTMLElement>(".accordion-body")!;
        const nowOpen = body.hidden;
        body.hidden = !nowOpen;
        acc.classList.toggle("open", nowOpen);
        if (nowOpen && !body.dataset.loaded) {
          body.innerHTML = `<p class="muted" style="padding-top:14px">Loading source…</p>`;
          try {
            const { template } = await api<{ template: any }>(`/v1/templates/${acc.dataset.id}`);
            body.innerHTML = `<pre style="margin-top:14px;max-height:400px">${escapeHtml(template.html ?? "")}</pre>`;
            body.dataset.loaded = "1";
          } catch (e) {
            body.innerHTML = `<div class="error-banner" style="margin-top:14px">${(e as Error).message}</div>`;
          }
        }
      };
    });
  } catch (e) {
    content.innerHTML = `<div class="error-banner">${(e as Error).message}</div>`;
  }
}

function escapeHtml(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
